import { createFileRoute } from '@tanstack/react-router';
import Requests from 'containers/Requests';

export const Route = createFileRoute('/_authenticated/requests/{-$requestId}')({
  component: RequestsPage,
});

function RequestsPage() {
  const { requestId } = Route.useParams();
  return <Requests requestId={requestId} />;
}
